// =========================================================================
// PRODUCT INFO INJECTION - Enhanced with better detection
// =========================================================================

(function() {
  let moveAttempted = false;

  function moveProductInfo() {
    if (moveAttempted) return;
    
    const sectionToMove = document.querySelector(".product-info-inject");
    const sidebar = document.querySelector(".npc-sidebar-price-box");
    
    // Only proceed if section exists
    if (!sectionToMove) {
      console.log('ℹ️ No .product-info-inject section found on this page');
      return;
    }
    
    // If sidebar found, do the move
    if (sidebar) {
      moveAttempted = true;
      sidebar.insertAdjacentElement("afterend", sectionToMove);
      console.log("✅ Product info moved successfully");
      observer.disconnect();
      return true;
    }
    
    return false;
  }

  // Watch for sidebar to appear
  const observer = new MutationObserver(() => {
    if (moveProductInfo()) {
      observer.disconnect();
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Try immediately
  moveProductInfo();

  // Try on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveProductInfo);
  }

  // Try on window load
  window.addEventListener('load', () => {
    setTimeout(moveProductInfo, 500);
  });

  // Stop observing after 15 seconds
  setTimeout(() => {
    observer.disconnect();
    if (!moveAttempted && document.querySelector(".product-info-inject")) {
      console.warn('⚠️ Could not find .npc-sidebar-price-box after 15 seconds');
    }
  }, 15000);
})();